<template>
  <div class="yxtbiz-group-main">
      <div class="yxtbiz-group-main-title">
        <Title :title="$t('pc_biz_group_edit' /* 编辑分组 */)" @close="onCancel"></Title>
      </div>
      <div class="yxtbiz-group-main-content">
          <div class="yxtbiz-group-main-content-left">
              <Group :member-list="memberList" :id="groupId" :group-list="groupList" :dragging="dragging"></Group>
          </div>
          <div class="yxtbiz-group-main-content-right">
              <Member :member-list="currentMember" :group-id="groupId" :action="action"></Member>
          </div>
      </div>
      <div class="yxtbiz-group-main-footer">
          <Handler :action="action" :group-list="groupList"></Handler>
          <Submit @cancel="onCancel" @submit="onSubmit"></Submit>
      </div>
      <div class="yxtbiz-group-main-drag">
          <span class="yxtbiz-group-main-drag__name">
            <yxtbiz-user-name :name="dragUser.fullname || '--'"></yxtbiz-user-name>
            (<yxtbiz-dept-name :name="dragUser.deptName || '--'"></yxtbiz-dept-name>)
          </span>
          <span v-if="showBadge" class="yxtbiz-group-main-drag__badge">{{selectedUserIds.value.length > 100 ? '99+' : selectedUserIds.value.length}}</span>
      </div>
  </div>
</template>

<script>
import Title from '../title.vue';
import Group from './components/group.vue';
import Member from './components/member.vue';
import Handler from './components/group-handle.vue';
import Submit from './components/submit.vue';
import { initDrag } from '../../services/drag';

export default {
  components: {
    Title,
    Group,
    Member,
    Handler,
    Submit
  },
  props: {
    memberList: {
      type: Array,
      require: true
    },
    groupList: {
      type: Array,
      require: true
    },
    groupId: {
      type: String | Number,
      require: true
    },
    deleteUser: {
      type: Function,
      default: ()=>{}
    },
    action: {
      type: Boolean,
      default: true
    }
  },
  inject: {
    dragMember: {
      default: () => {}
    },
    selectedUserIds: {
      value: {
        default: []
      }
    },
    close: {
      type: Function,
      default: ()=>{}
    },
    submit: {
      type: Function,
      default: ()=>{}
    }
  },
  computed: {
    showBadge() {
      if (this.selectedUserIds.value.length < 1) {
        return false;
      }
      if (!this.selectedUserIds.value.includes(this.dragUser.userId)) {
        return false;
      }
      if (this.selectedUserIds.value.length === 1 && this.selectedUserIds.value[0] === this.dragUser.userId) {
        return false;
      }
      return true;
    },
    groupMemberIds() {
      let ids = [];
      for (let i = 0;i < this.groupList.length;i++) {
        ids = ids.concat(this.groupList[i].groupMemberList.map(item=>item.userId));
      }
      return ids;
    },
    currentMember() {
      if (this.groupId) {
        return this.groupList.find(item=>item.id === this.groupId).groupMemberList;
      }
      const members = this.memberList.filter(item=>!this.groupMemberIds.includes(item.userId));
      return members;
    }
  },
  data() {
    return {
      dragUser: {},
      dragging: false
    };
  },
  mounted() {
    initDrag(
      '.yxtbiz-group-main', // 拖动容器
      '.yxtbiz-group-main .yxt-table__body-wrapper tr', // 拖动节点
      '.yxtbiz-group-main .group-item,.yxtbiz-group-main .group-header-add, .group-content-not', // 目标节点
      '.yxtbiz-group-main .yxtbiz-group-main-drag', // 展示元素
      this.onDragStart, // 开始拖动回调
      this.onDragEnd // 拖动结束回调 拖动节点拖入目标节点
    );
  },
  methods: {
    onDragStart(dragValue) {
      this.dragging = true;
      this.dragUser = this.memberList.find(user => user.userId === dragValue);
    },
    onDragEnd(targetValue, dragValue) {
      this.dragging = false;
      targetValue && this.dragMember(targetValue, dragValue);
    },
    onCancel() {
      this.close();
    },
    onSubmit() {
      this.submit();
    }
  }

};
</script>

<style lang="scss" scoped>
.yxtbiz-group-main{
    width: 960px;
    display: flex;
    flex-direction: column;
    height: 100%;
    position: relative;
    user-select: none;
    -ms-user-select: none;

    &-title{
        padding: 16px 24px;
        border-bottom: 1px solid #E9E9E9 ;
        height: 56px;
        box-sizing: border-box;
    }
    &-content{
        flex-grow: 1;
        display: flex;
        height: calc(100% - 122px);
        &-left{
            border-right: 1px solid #E9E9E9;
            width: 280px;
            padding: 24px 24px 24px 24px;
        }
        &-right{
            flex-grow: 1;
            padding: 24px 24px 24px 24px;
            overflow: hidden;
        }
    }
    &-footer{
        height: 56px;
        background: #FFFFFF;
        box-shadow: 0px -2px 8px 0px rgba(0, 0, 0, 0.08);
        width: 100%;
        display: flex;
        align-self: center;
        justify-content: space-between;
        padding: 12px;
    }
    &-drag{
        width: 188px;
        height: 44px;
        padding: 0 16px;
        background: #FFFFFF;
        box-shadow: 0px 4px 24px 0px rgba(0, 0, 0, 0.12);
        border-radius: 4px;
        border: 1px solid #E9E9E9;
        position: absolute;
        top: 5px;
        left: 5px;
        font-size: 14px;
        color: #262626;
        display: flex;
        align-items: center;
        opacity: 0;
        pointer-events: none;

        &__name{
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis; 
        }
        &__badge{
            position: absolute;
            height: 20px;
            background: #F5222D;
            border: 2px solid #FFFFFF;
            border-radius: 8px;
            top: -10px;
            right: 0;
            transform: translateX(50%);
            font-size: 12px;
            color: #fff;
            padding: 0px 4px;
            display: flex;
            align-items: center;
        }
    }
}
</style>
